import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBrand } from '../context/BrandContext';

export default function Login() {
  const brand = useBrand();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const data = await login(username, password);
      if (data.user.role === 'superadmin') {
        navigate('/app/superadmin');
      } else {
        navigate('/app');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h1>{brand.name}</h1>
        <p className="subtitle">Log ind for at fortsætte</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>E-mail</label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Adgangskode</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="btn btn-primary">Log ind</button>
        </form>
        <div style={{textAlign: 'center', marginTop: '1.25rem'}}>
          <Link to="/" style={{fontSize: '0.85rem', color: '#718096', textDecoration: 'none'}}>
            &larr; Tilbage til {brand.fullName}
          </Link>
        </div>
      </div>
    </div>
  );
}
